#@export GliveBooking.FilteredCollections.Base

class GliveBooking.FilteredCollections.Base extends Backbone.Obscura
